// extracted by mini-css-extract-plugin
export default {"menu_portal":"HamburgerMenu_menu_portal__m1F2M","isOpen":"HamburgerMenu_isOpen__7218B","overlay":"HamburgerMenu_overlay__4RZ5n"};